enum FilteringEntityType {
  UPLOAD = 'uploadFilteredEntity',
  UPLOAD_FILE = 'uploadFileFilteredEntity',
  LIFTING_ACTION_SUMMARY = 'liftingActionSummaryFilteredEntity',
  ELECTRICAL_ACTION_SUMMARY = 'electricalActionSummaryFilteredEntity',
}

export default FilteringEntityType;
